import { useNavigate, useSearch } from '@tanstack/react-router';

import { Tabs } from '../cdl/Tabs/Tabs';
import { Text } from '../cdl/Text/Text';
import { translate } from '../common/helpers/translate.helper';
import { useDocumentTitle } from '../common/hooks/useDocumentTitle';
import { Page } from '../common/Page/Page';
import { Box } from '../common/ui/Box';

import { BassNetPageContent } from './BassNetPageContent';
import { CloudFleetManagerPageContent } from './CloudFleetManagerPageContent';
import { Integration } from './Integration';
import { MaerskPageContent } from './MaerskPageContent';
import { OnePortPageContent } from './OnePortPageContent';

export const IntegrationsOverviewPage = () => {
    useDocumentTitle(translate('page.integrationsOverview'));

    const search = useSearch({ from: '/_app/integrations' });
    const navigate = useNavigate({ from: '/integrations' });

    return (
        <Page>
            <Box display="grid" rowGap={4}>
                <Text variant="headline" as="h1">
                    {translate('integrationsOverview.headline')}
                </Text>

                <Tabs
                    selectedContext={search.integration}
                    onSelect={(integration: Integration) => navigate({ search: { integration } })}
                    totals={{
                        [Integration.MAERSK]: null,
                        [Integration.ONE_PORT]: null,
                        [Integration.BASS_NET]: null,
                        [Integration.CLOUD_FLEET_MANAGER]: null,
                    }}
                />

                {search.integration === Integration.MAERSK ? <MaerskPageContent /> : null}
                {search.integration === Integration.ONE_PORT ? <OnePortPageContent /> : null}
                {search.integration === Integration.BASS_NET ? <BassNetPageContent /> : null}
                {search.integration === Integration.CLOUD_FLEET_MANAGER ? <CloudFleetManagerPageContent /> : null}
            </Box>
        </Page>
    );
};
